/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Trace_Reason_Grower_MissingInputs */

const vi_order_lot_trace_reason_grower_missing = /** @type {(inputs: Order_Lot_Trace_Reason_Grower_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn mua không có hộ dân gắn`)
};

/**

* @param {Order_Lot_Trace_Reason_Grower_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_reason_grower_missing = /** @type {((inputs?: Order_Lot_Trace_Reason_Grower_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_Reason_Grower_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_reason_grower_missing(inputs)
});